export default "__VITE_ASSET__DXd1afPU__"